import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Button } from '../Button'
import style from './modal.style'

export class Modal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.keyUpListener = this.keyUpListener.bind(this)
  }
  componentDidMount() {
    window.addEventListener('keyup', this.keyUpListener)
    document.body.classList.add(midas.modalOpen)
  }
  componentWillUnmount() {
    window.removeEventListener('keyup', this.keyUpListener)
    document.body.classList.remove(midas.modalOpen)
  }
  keyUpListener() {
    if (event.keyCode === 27) {
      this.props.onBack()
    }
  }

  modalSize() {
    switch (this.props.size) {
      case 'small':
        return midas.grid480
      case 'medium':
        return midas.grid640
      case 'large':
        return midas.grid960
      default:
        return midas.grid480
    }
  }
  render() {
    if (!this.props.show) {
      return null
    }

    return (
      <div
        className={this.props.show ? `${midas.modal} ${midas.active}` : null}
      >
        <div className={midas.modalOverlay} />
        <div
          style={style.modalContainer}
          className={`${midas.modalContainer} ${this.modalSize()}`}
          role="dialog"
        >
          <div className={midas.modalHeader}>
            <h3 className={midas.modalTitle}>{this.props.title}</h3>
            <button
              className={`${midas.button} ${midas.buttonClear}`}
              aria-label={this.props.closeText}
              onClick={() => this.props.onBack()}
            />
          </div>
          <div className={midas.modalBody}>
            <div className={midas.content}>{this.props.children}</div>
          </div>
          <div className={midas.modalFooter}>
            {this.props.actions.map(
              action =>
                action.typeName && (
                  <Button
                    key={action.text}
                    typeName={action.typeName}
                    primaryColor={action.primaryColor}
                    styleName={action.styleName}
                    text={action.text}
                    onClick={e => action.func(e)}
                    disabled={action.disabled}
                  />
                ),
            )}
            <Button
              typeName="link"
              text={this.props.closeText}
              onClick={() => this.props.onBack()}
            />
          </div>
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  actions: PropTypes.array,
  closeText: PropTypes.string.isRequired,
  size: PropTypes.string,
}

Modal.defaultProps = {
  children: null,
  title: '',
  actions: [],
  size: 'small',
}
